import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgChatten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Chatten_svg__a)">
      <mask
        id="Chatten_svg__b"
        width={28}
        height={29}
        x={6}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M34 20a14 14 0 1 0-6 11.47L33 33l-1.53-5A14 14 0 0 0 34 20m-20 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
        />
      </mask>
      <g mask="url(#Chatten_svg__b)">
        <path
          fill="#F7A941"
          d="m32.34 52.49-12.25-7.07 7.08-12.24z"
        />
        <path
          fill="#F18700"
          d="m27.17 33.18-7.08 12.24-12.24-7.07z"
        />
        <path
          fill="#F7A941"
          d="m27.17 33.18 12.24 7.07-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m46.48 28-7.07 12.25-12.24-7.07zM21.99 13.86 9.74 6.79l7.07-12.25z"
        />
        <path
          fill="#F18700"
          d="M-2.5-.28 9.74 6.79 2.67 19.03z"
        />
        <path
          fill="#F7A941"
          d="M2.67 19.03 9.74 6.79l12.25 7.07zM16.81-5.46 9.74 6.79-2.5-.28zM41.31 8.68 29.06 1.61l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m16.81-5.46 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m21.99 13.86 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m21.99 13.86 12.25 7.07-7.07 12.25zM41.31 8.68l-7.07 12.25-12.25-7.07zM27.17 33.18l7.07-12.25L46.48 28z"
        />
        <path
          fill="#F18700"
          d="m2.67 19.03 12.25 7.08-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m27.17 33.18-12.25-7.07 7.07-12.25zM21.99 13.86l-7.07 12.25-12.25-7.08z"
        />
        <path
          fill="#F18700"
          d="m7.85 38.35 7.07-12.24 12.25 7.07zM7.85 38.35-4.4 31.28l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m-11.47 43.53 7.07-12.25 12.25 7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Chatten_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgChatten);

export default ForwardRef;
